var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticStyle:{"margin":"18px"}},[_c('v-btn',{on:{"click":_vm.OpenAddFeatures}},[_vm._v("Add Features")]),_c('app-add-features',{ref:"GetCourseDetailsList",attrs:{"dialog":_vm.AddFeatureDialog},on:{"close":_vm.CloseDialog}}),_c('app-feature-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }